import { GetGoogleIdTokenArgs } from 'types/api/arguments/get-google-id-token-args'
import { GetGoogleIdTokenResp } from 'types/api/response/get-google-id-token-resp'

import { api } from './api'

export const getGoogleIdToken = ({
  code,
  state,
  action,
  isLocalRedirectEnabled,
}: GetGoogleIdTokenArgs) =>
  api.get<GetGoogleIdTokenResp>('/google_user/token', {
    params: {
      code,
      state,
      take_action: action,
      next_local_redirect: isLocalRedirectEnabled,
    },
  })
